import React from 'react';
import { BondInsuranceForGetCompleteBondInsuranceProposalByIdResponseDTO } from '../../../../../dtos/bond-insurance-proposal-list/get-complete-bond-insurance-proposal-by-id-response.dto';
import { maskCnpj, maskCpfOrCnpj, maskMoney } from '../../../../../services/masks';
import { BrDateToDate, DateToStringDate } from '../../../../../services/date';
import { FieldLabel } from '../../../../../styles';

export type Props = {
  bondInsurance: BondInsuranceForGetCompleteBondInsuranceProposalByIdResponseDTO;
};

const FieldDisplay = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <div style={{ paddingBottom: '16px' }}>
    <div
      style={{
        fontWeight: 'bold',
        marginBottom: '0.35em',
        color: '#555',
        fontSize: '0.85em',
        textTransform: 'uppercase'
      }}
    >
      {label}
    </div>
    <div style={{ fontSize: '0.95em', wordBreak: 'break-word' }}>
      {value || 'Indisponível'}
    </div>
  </div>
);

export const BondInsuranceLegalTenantDetails = (props: Props) => {
  const { legalTenant } = props.bondInsurance;

  return (
    <div className="row" style={{ paddingLeft: '8px', paddingRight: '8px' }}>
      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="EMPRESA" value={legalTenant.company} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="CNPJ" value={maskCnpj(legalTenant.document)} />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="E-MAIL" value={legalTenant.email} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="TELEFONE" value={legalTenant.phone} />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="DATA DE CONSTITUIÇÃO"
            value={DateToStringDate(BrDateToDate(legalTenant.foundation_date))}
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="ÚLT. ALT. CONTRATUAL"
            value={DateToStringDate(
              BrDateToDate(legalTenant.last_contractual_alteration_date)
            )}
          />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="CAPITAL SOCIAL (R$)"
            value={maskMoney(`${legalTenant.share_capital}`)}
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="CAPITAL INTEGRALIZADO (R$)"
            value={maskMoney(`${legalTenant.paid_in_capital}`)}
          />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="FATURAMENTO ANUAL (R$)"
            value={maskMoney(`${legalTenant.anual_revenue}`)}
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="NOME CONTATO" value={legalTenant.contact_name} />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="TELEFONE CONTATO" value={legalTenant.contact_phone} />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="LOGRADOURO" value={legalTenant.street} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="NÚMERO" value={legalTenant.number} />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="COMPLEMENTO" value={legalTenant.complement} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="BAIRRO" value={legalTenant.district} />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="CIDADE" value={legalTenant.city} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="ESTADO" value={legalTenant.state} />
        </div>
      </div>
      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="CEP" value={legalTenant.zip_code} />
        </div>
      </div>

      {legalTenant.partners?.map((partner, index) => (
        <div
          key={`partner-legal-${index}`}
          style={{ marginTop: '1.5em', borderTop: '1px dashed #ccc', paddingTop: '1em' }}
        >
          <FieldLabel
            style={{
              color: '#364445',
              fontSize: '1.0em',
              fontWeight: 'bold',
              marginBottom: '1em'
            }}
          >{`${index + 1}º SÓCIO`}</FieldLabel>
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
              <FieldDisplay label="NOME" value={partner.name} />
            </div>
            <div style={{ flex: 1, boxSizing: 'border-box' }}>
              <FieldDisplay label="CPF" value={maskCpfOrCnpj(partner.document)} />
            </div>
          </div>
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
              <FieldDisplay label="RENDA (%)" value={`${partner.percent} %`} />
            </div>
            <div style={{ flex: 1, boxSizing: 'border-box' }}>
              <FieldDisplay
                label="DATA DE ENTRADA"
                value={DateToStringDate(BrDateToDate(partner.date_of_entry))}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
